import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/courses/[slug]/CoursePageClient.tsx");
